var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoticonHappyPlusOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0013 5.66667C4.0013 5.11333 4.44797 4.66667 5.0013 4.66667C5.55464 4.66667 6.0013 5.11333 6.0013 5.66667C6.0013 6.22 5.55464 6.66667 5.0013 6.66667C4.44797 6.66667 4.0013 6.22 4.0013 5.66667ZM7.33463 11C8.88797 11 10.208 10.0267 10.7413 8.66667H3.92797C4.4613 10.0267 5.7813 11 7.33463 11ZM9.66797 6.66667C10.2213 6.66667 10.668 6.22 10.668 5.66667C10.668 5.11333 10.2213 4.66667 9.66797 4.66667C9.11463 4.66667 8.66797 5.11333 8.66797 5.66667C8.66797 6.22 9.11463 6.66667 9.66797 6.66667ZM14.0013 0H12.668V1.33333H11.3346V2.66667H12.668V4H14.0013V2.66667H15.3346V1.33333H14.0013V0ZM12.668 7.33333C12.668 10.28 10.2813 12.6667 7.33463 12.6667C4.38797 12.6667 2.0013 10.28 2.0013 7.33333C2.0013 4.38667 4.38797 2 7.33463 2C8.30797 2 9.21463 2.26667 10.0013 2.72V1.22667C9.1813 0.866667 8.2813 0.666667 7.32797 0.666667C3.64797 0.666667 0.667969 3.65333 0.667969 7.33333C0.667969 11.0133 3.64797 14 7.32797 14C11.0146 14 14.0013 11.0133 14.0013 7.33333C14.0013 6.63333 13.888 5.96667 13.688 5.33333H12.268C12.5213 5.95333 12.668 6.62667 12.668 7.33333Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoticonHappyPlusOutline);
export default __webpack_public_path__ + "static/media/emoticonHappyPlusOutline.ae294b125389cae51ce7ba2d14886e6f.svg";
export { ForwardRef as ReactComponent };